import { createContext, useContext, useMemo, useState } from "react";

const DEFAULT_IMAGE_VERSION = "08102026-2";

let currentImageVersion = DEFAULT_IMAGE_VERSION;

const ImageVersionContext = createContext({
  imageVersion: DEFAULT_IMAGE_VERSION,
  setImageVersion: () => {},
});

export const ImageVersionProvider = ({ children }) => {
  const [imageVersion, setImageVersion] = useState(DEFAULT_IMAGE_VERSION);

  currentImageVersion = imageVersion;

  const value = useMemo(
    () => ({ imageVersion, setImageVersion }),
    [imageVersion]
  );

  return (
    <ImageVersionContext.Provider value={value}>
      {children}
    </ImageVersionContext.Provider>
  );
};

export const useImageVersion = () => useContext(ImageVersionContext);

export const withImageVersion = (url) => {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (/[?&]v=/.test(url)) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${currentImageVersion}`;
};

export const useImageUrl = () => {
  useImageVersion();
  return withImageVersion;
};
